import { Theme } from '@mui/material';

/**
 * Common styling utilities for objective components
 */

export const getValueProps = (theme: Theme) => ({
  fontSize: {
    xs: theme.typography.pxToRem(19),
    sm: theme.typography.pxToRem(20),
  },
});

export const getMainTextStyle = (theme: Theme) => ({
  color: theme.palette.text.main,
});

export const getSecondaryTextStyle = (theme: Theme) => ({
  color: theme.palette.text.second,
});

export const getStackGap = () => ({
  xs: 2,
  sm: 3,
  md: 8,
});
